var OrderService = /** @class */ (function () {
    function OrderService($http, $log) {
        'ngInject';
        this.$http = $http;
        this.$log = $log;
        this.recentOrderRequest = null;
    }
    OrderService.prototype.getOrders = function (pageNumber, pageSize, sortBy, sortDirection, days, query) {
        var queryParams = {
            pageNumber: pageNumber ? pageNumber : 1,
            pageSize: pageSize ? pageSize : 10,
            sortBy: sortBy ? sortBy : "createDate",
            sortDirection: sortDirection ? "asc" : "desc",
            days: days ? days : null,
            query: query ? query : null
        };
        return this.$http.get('api/account/orders', { params: queryParams })
            .then(function success(response) {
            if (response.data && response.data.response) {
                return response.data.response;
            }
        });
    };
    OrderService.prototype.getRecentOrders = function (isNewRequest) {
        var self = this;
        if (!self.recentOrderRequest || isNewRequest) {
            self.recentOrderRequest = this.$http.get('api/account/orders/recent')
                .then(function success(response) {
                if (response.data && response.data.response) {
                    return response.data.response;
                }
            }, function error(response) {
                self.$log.error('error response.....', response);
            });
        }
        return self.recentOrderRequest;
    };
    return OrderService;
}());
export { OrderService };
//# sourceMappingURL=order.service.js.map